import classNames from 'classnames';
import React from "react";

import { FormSectionElements } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { HintExpansionComponent } from '../odsCalloutBox/HintExpansionComponent';
import { getRootComponent } from '../../utilities/ElementUtils';

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {
}

export class RegistrantIdenticationNumberComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  
    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
  }
  
  onChange = (e) => {
    let field = this.props.field;
    let val = e.target.value;
    if (val) {
      val = val.trim();
    }
    field.Value = val;
  
    FormValidationUtils.validateRegistrantIdentificationNumber(field);
    
    this.props.callbackElement(getRootComponent(field));
  }
  
  onBlur = (e) => {
    let field = this.props.field;
    FormValidationUtils.evalRegistrantIdentificationNumberRegularExpression(field)
  
    if (field.Valid) {
      FormValidationUtils.runJavascript(field);
    }
  
    this.props.callbackElement(getRootComponent(field));
  }

  onKeyDown = (e) => {
    if(e.ctrlKey && (e.key === 'v' || e.key === 'V')){
      return
    }
    // Only allow numbers, backspace, delete, tab, and arrow keys
    if (!/[\d]/.test(e.key) && 
        e.key !== 'Backspace' && 
        e.key !== 'Delete' && 
        e.key !== 'Tab' &&
        !e.key.startsWith('Arrow')) {
      e.preventDefault();
    }    
  }

  render() {
    let field = this.props.field;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>
          <div key={'fdLbl_div_' + field.Id} >
            {labelControlArray}
          </div>
          <div>
            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />
          </div>
          <div key={'fdIpt_div_' + field.Id} >
            <div>
              <input className={field.Valid ||!field.Touched ? 'ontario-input ontario-input--9-char-width' : 'ontario-input ontario-input--9-char-width ontario-input__error'}
                id={field.LoadBindName}  key={'fdIpt_' + field.Id} 
                aria-label="Registrant Identification Number"  type="text" maxLength={9} pattern="[0-9]{9}" 
                aria-required={requiredField} 
                aria-invalid={!field.Valid ||field.Touched ? true : undefined}
                aria-describedby={
                  [!field.Valid && `${field.LoadBindName}-${field.Id}-error`, hintHtml && `hint-text-${field.LoadBindName}`]
                    .filter(Boolean)
                    .join(' ') || undefined
                }                value={field.Value} readOnly={field.ReadOnly}
                onChange={this.onChange} onBlur={this.onBlur} onKeyDown={this.onKeyDown}
                />
            </div>
          </div>
          {field.hintExpansionTitle && editable && field.Visible && <HintExpansionComponent
            isEng={this.props.isEng}
            calloutType={field.callOutBoxType}
            Visible={field.Visible}
            bodyMsg={this.props.isEng ? field.callOutBoxBody : field.callOutBoxBodyFRA}
            title={this.props.isEng ? field.callOutBoxTitle : field.callOutBoxTitleFRA}
            hintExpansionTitle={this.props.isEng ? field.hintExpansionTitle : field.hintExpansionTitleFRA}
            field={field}/>}
        </div>);
    } else {
      controlArray.push(
        <div className={classNames('pdf-two-column', { 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >
          <div>{title}</div>
          <div> {field.Value}</div>
        </div>
      );
    }
    return controlArray;
  }
}